import React, { useState, useCallback } from 'react';
import i18next from 'i18next';
import { marked } from 'marked';
import { Repeat, RepeatTiny } from '../../../StyledComponents/Repeat';
import { VisualHeading } from '../../../StyledComponents/Heading';
import OptionBox from '../../../StyledComponents/OptionBox';
import { OptionBoxContent } from '../../../StyledComponents/OptionBox/wrapper';
import Content from '../../../StyledComponents/Content';
import { ButtonInline } from '../../../StyledComponents/Button';
import { InsuranceOption } from '../../../@types/codegen/types';
import InsuranceFreeModal from './InsuranceFreeModal';

interface InsuranceOptions {
  insuranceOptions: InsuranceOption[];
}

const Insurance = ({ insuranceOptions }: InsuranceOptions) => {
  const [modal, setModal] = useState(false);
  const toggleModal = useCallback(() => setModal(!modal), [modal]);
  if (!insuranceOptions.length) {
    return null;
  }

  return (
    <>
      {modal && <InsuranceFreeModal onClose={toggleModal} insuranceOptions={insuranceOptions[0]} />}
      <Repeat>
        <RepeatTiny>
          <VisualHeading>
            {insuranceOptions[0]?.insuranceHeader ?? i18next.t('item.insurance')}
          </VisualHeading>
        </RepeatTiny>
        <RepeatTiny>
          <>
            {insuranceOptions.map((insuranceOption, index) => (
              <OptionBox
                key={`${insuranceOption.url}-${index}`}
                logo={insuranceOption.logotype || undefined}
                logoAlt={insuranceOption.name || i18next.t('common.logotype') || ''}
              >
                {insuranceOption.description && (
                  <Content
                    dangerouslySetInnerHTML={{
                      __html: marked(`${insuranceOption.description}`),
                    }}
                  />
                )}
                <OptionBoxContent>
                  <p>
                    <ButtonInline
                      onClick={toggleModal}
                      title={i18next.t('common.moreInformation') || ''}
                    >
                      {i18next.t('common.moreInformation')}
                    </ButtonInline>
                  </p>
                </OptionBoxContent>
              </OptionBox>
            ))}
          </>
        </RepeatTiny>
      </Repeat>
    </>
  );
};

export default Insurance;
